export default "__VITE_ASSET__BOeA5qbC__";